<template>
    <div class="goodList" :style="wrapStyle">
      <router-link
        :to="{ path: '/detail/' + item.id }"
        class="item acea-row row-between-wrapper"
        v-for="(item, index) in goodList"
        :key="index"
        :style="boxStyle"
      >
        <div class="pictrue">
          <img :src="item.image" :style="imageStyle" class="image" />
          <img
            src="@assets/images/one.png"
            class="numPic"
            v-if="isSort === true && index === 0"
          />
          <img
            src="@assets/images/two.png"
            class="numPic"
            v-if="isSort === true && index === 1"
          />
          <img
            src="@assets/images/three.png"
            class="numPic"
            v-if="isSort === true && index === 2"
          />
        </div>
            <div class="underline" :style="bottomBoxStyle">
            <div class="text">
                <div class="line1" :style="textTitleStyle">{{ item.store_name }}</div>
                <div class="money font-color-red" v-if="isPrice">
                <span class="num">{{ item.price }}
                </span>
                </div>
                <div class="vip-money acea-row row-middle" v-if="isShowSale">
                <div
                    v-show="false"
                    class="vip"
                    v-if="item.vip_price && item.vip_price > 0"
                >
                    点{{ item.vip_price || 0
                    }}<img src="@assets/images/vip.png" class="image" />
                </div>
                </div>
                <div class="movie-box acea-row row-middle row-between author-wrap" v-if="isAuthor">
                <span class="author"><span v-if="item.author">作者:{{item.author}}</span></span>
                <div class="money font-color-red">
                    <span class="num">{{ item.price }}</span>
                </div>
                </div>
            </div>
            </div>
        <div
          v-if="isShowShopCart"
          class="iconfont icon-gouwuche cart-color acea-row row-center-wrapper"
        ></div>
      </router-link>
    </div>

  </template>
  <script>
  export default {
    name: "bookGoodList",
    props: {
        goodList: {
        type: Array,
        default: () => []
      },
      isSort: {
        type: Boolean,
        default: true
      },
      isShowSale: {
        type: Boolean,
        default: true
      },
      isPrice: {
        type: Boolean,
        default: true
      },
      isAuthor: {
        type: Boolean,
        default: false
      },
      isShowShopCart: {
        type: Boolean,
        default: true
      },
      boxStyle: {
        type: Object,
        default: ()=>{}
      },
      wrapStyle: {
        type: Object,
        default: ()=>{}
      },
      bottomBoxStyle: {
        type: Object,
        default: ()=>{}
      },
      imageStyle: {
        type: Object,
        default: ()=>{}
      },
      textTitleStyle: {
        type: Object,
        default: ()=>{}
      }
    },
    data: function() {
      return {};
    }
  };
  </script>
  <style scoped>
  .goodList .item{
    border-radius: .2rem;
    margin-left: .22rem;
    box-shadow: 0.06rem 0.06rem 0.1rem 0.02rem #ededed;
    -webkit-box-shadow: 0.06rem 0.06rem 0.1rem 0.02rem #ededed;
    border: none;
  }
  .goodList .item .pictrue .image{
    width: 1.5rem;
    margin: 0 auto;
  }
  .goodList .item .underline {
    border: none;
    width: 100%;
  }
  .author-wrap > .money {
    margin-top: 0 !important;
  }
  .author-wrap {
    margin-top: 0.1rem;
  }
  .author-wrap > .author {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  </style>